import type { FC, MouseEventHandler } from "react"
import React, { useRef } from "react"

import { useRecoilValue } from "recoil"

import { findProjectedEdgeState } from "../../state/elements"
import { useEraseEdge } from "../../state/elements/transactions/deleteEdge"
import { useDesignateEdge } from "../../state/elements/transactions/designateEdge"
import { useSegmentEdge } from "../../state/elements/transactions/segmentEdge"
import { flawedEdgeIndex } from "../../state/flaws"
import { phaseState } from "../../state/phase"
import type { Tool } from "../../state/tool"
import { toolState } from "../../state/tool"

interface SegmentProps {
  id: string
}

export const Edge_Internal: FC<SegmentProps> = ({ id }) => {
  const { p1, p2, props } = useRecoilValue(findProjectedEdgeState(id))
  const tool = useRecoilValue(toolState)
  const segmentEdge = useSegmentEdge(id)
  const designateEdge = useDesignateEdge(id)
  const edgeDeletion = useEraseEdge(id)
  const phase = useRecoilValue(phaseState)

  const flawedIds = useRecoilValue(flawedEdgeIndex)
  const isInvalid = flawedIds.includes(id)

  const nodeRef = useRef(null)

  const onMouseDownFor: Partial<Record<Tool, MouseEventHandler>> = {
    Draw: (e) => (e.stopPropagation(), segmentEdge()),
    EdgeDesignator: designateEdge,
    Erase: (e) => (e.stopPropagation(), edgeDeletion()),
  }

  return (
    <g ref={nodeRef} onMouseDown={onMouseDownFor[tool]}>
      {(phase === `Outline` || phase === `Edge Designation`) && (
        <line
          x1={p1.x}
          y1={p1.y}
          x2={p2.x}
          y2={p2.y}
          stroke="transparent"
          strokeWidth={15}
        />
      )}
      <line
        x1={p1.x}
        y1={p1.y}
        x2={p2.x}
        y2={p2.y}
        stroke={isInvalid ? `var(--warning)` : `white`}
        strokeWidth={5}
      />
      <line x1={p1.x} y1={p1.y} x2={p2.x} y2={p2.y} {...props} />
      {/* {isShownInvalid &&  */}
      {/* <CoordinateTooltip says={id} where={midpoint} /> */}
      {/* } */}
    </g>
  )
}

export const Edge = React.memo(Edge_Internal)
